import { render, staticRenderFns } from "./PopupDownloadDocument.vue?vue&type=template&id=73075bfa&"
import script from "./PopupDownloadDocument.vue?vue&type=script&lang=js&"
export * from "./PopupDownloadDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports